// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"247":"caa1c8c4","525":"3076c4bf"}[chunkId] + ".css";
};